import { useId } from 'react'

import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'

import { Form } from '../../Form/index.js'
import { T, useI18n } from '../../i18n/index.js'

interface PollFormTitleProps {
  disabled?: boolean
}

export function PollFormTitle({ disabled }: PollFormTitleProps) {
  const id = useId()
  const { $t } = useI18n()

  return (
    <div className="space-y-2">
      <FormControl.Label htmlFor={`poll-question-${id}`}>
        <T id="Poll.Question" defaultMessage="Question" />
      </FormControl.Label>
      <Form.Textarea
        id={`poll-title-${id}`}
        name="title"
        placeholder={$t({
          id: 'Poll.Question.Placeholder',
          defaultMessage: 'Ask a question',
        })}
        disabled={disabled}
        validation={{
          required: true,
        }}
      />
    </div>
  )
}
